import React, {
  useCallback,
  useMemo,
  useContext,
  useState
} from 'react';

import {
  FormGroup,
  Label,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';

import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';


import FieldError from "../../helper/FieldError";

import {
  inputId,
  inputName,
} from '../../helper/form';

import WorkflowDiagramContext from '../diagram_context';

const WorkflowStageFileItemAttributes = props => {

  const formName = _.uniqueId('stage_item_file');

  const [openModalAdvancedConfiguration, setOpenModalAdvancedConfiguration] = useState(false)

  const {
    fileItem,
    index,
    setCurrentNode,
    currentNode,
    configuration: {
      stageForm,
      showGroupName
    },
    data: {
      groupNameOptions = []
    }
  } = props;

  const setFileItem = _fileItem => {
    setCurrentNode(prevState => {
      prevState.data[stageForm]['file_items'][index] = {
        ...prevState.data[stageForm]['file_items'][index],
        ..._fileItem
      }

      return { ... prevState }
    })
  }

  const onChangeFile = (event, key) => {
    // Si el campo se encuentra desabilitado no se debe poder modificar
    if(!fileItem.is_disabled){
      let value = event.target.value;
      const type = event.target.type;

      if(type == 'checkbox'){
        value = event.target.checked;
      }

      let fileChanges = {}

      fileChanges[key] = value

      setCurrentNode(prevState => {
        prevState.data[stageForm]['file_items'][index] = {
          ...prevState.data[stageForm]['file_items'][index],
          ...fileChanges
        }

        return { ... prevState }
      })
    }
  }

  // ---------- START NAME ----------
  const nameInput = () => {
    return(
      <td>
        <FormGroup>
          <FieldError errors={ fileItem?.errors?.name || [] }>
            <Input
              value={ fileItem?.name || '' }
              onChange={ e => onChangeFile(e, 'name') }
              invalid={ _.has(fileItem, 'errors.name') }
              disabled={ fileItem?.is_disabled || false }
            />
          </FieldError>
        </FormGroup>
      </td>
    )
  }
  // ---------- END NAME ----------

  // ---------- START IS REQUIRED ----------
  const isRequiredSwitchInput = () => {
    if(stageForm === "output_stage_form"){
      return(
        <td>
          <FormGroup>
            <div className='custom-switch'>
              <FieldError errors={ [] }>
                <Input
                  className='custom-control-input'
                  type='checkbox'
                  value={ '1' }
                  onChange={ e => onChangeFile(e, 'is_required') }
                  id={ inputId(formName, 'is_required') }
                  name={ inputName(formName, 'is_required') }
                  checked={ fileItem.is_required || false }
                  disabled={ fileItem?.is_disabled || false }
                />
                <Label
                  className='custom-control-label'
                  htmlFor={ inputId(formName, 'is_required') }
                />
              </FieldError>
            </div>
          </FormGroup>
        </td>
      )
    }
  }
  // ---------- END IS REQUIRED ----------

  // ---------- START GROUP NAME ----------
  const groupNameSelectOptions = () => {
    return _.map(groupNameOptions, option => {
      return {
        label: option,
        value: option
      }
    })
  }

  const groupNameSelectedOption = useMemo(() => {
    if(_.includes(groupNameOptions, fileItem.group_name)){
      return {
        label: fileItem.group_name,
        value: fileItem.group_name,
      }
    } else {
      return null
    }
  }, [fileItem.group_name])

  const onCreateOptionGroupName = value => {
    onChangeFile(
      { target: { value: value }},
      'group_name'
    )
  }

  const groupNameSelectInput = () => {
    if(showGroupName){
      return(
        <td className='text-center'>
          <FormGroup>
            <CreatableSelect
              isClearable
              options={ groupNameSelectOptions() }
              onChange={ e => onChangeFile({ target: { value: e.value}}, 'group_name') }
              onCreateOption={ onCreateOptionGroupName }
              value={ groupNameSelectedOption }
              placeholder="Crea o Selecciona Grupo de Datos"
            />
          </FormGroup>
        </td>
      )
    }
  }
  // ---------- END GROUP NAME ----------

  // ---------- START ADVANCED CONFIGURATION  ----------
  const advancedConfigurationButton = () => {
    if(stageForm == 'output_stage_form'){
      return(
        <td>
          <Button
            outline
            color='primary'
            size='xs'
            onClick={ e => setOpenModalAdvancedConfiguration(true) }
          >
            <i className="fas fa-cog"></i>
          </Button>
        </td>
      )
    }
  }

  const toggleOpenModalAdvancedConfiguration = () => {
    setOpenModalAdvancedConfiguration(!openModalAdvancedConfiguration)
  }

  const advancedConfigurationModal = () => {
    return(
      <WorkflowStageFileItemModalAdvancedConfiguration
        openModalAdvancedConfiguration={ openModalAdvancedConfiguration }
        fileItem={ fileItem }
        currentNode={ currentNode }
        setCurrentNode={ setCurrentNode }
        configuration={
          { ... props?.configuration, formName: formName }
        }
        callbacks={{
          toggleOpenModalAdvancedConfiguration: toggleOpenModalAdvancedConfiguration,
          setFileItem: setFileItem
        }}
      />
    )
  }
  // ---------- END ADVANCED CONFIGURATION  ----------

  // ---------- START DELETE  ----------
  const deleteButton = () => {
    return(
      <td>
        <Button
          outline
          color='danger'
          size='xs'
          onClick={ e => onChangeFile({ target: { value: true } }, '_destroy') }
          disabled={ fileItem?.is_disabled || false }
        >
          <i className="fas fa-trash"></i>
        </Button>
      </td>

    )
  }
  // ---------- END DELETE  ----------

  return(
    <tr className={ `${ fileItem._destroy ? 'd-none' : '' } `} >
      { groupNameSelectInput() }
      { nameInput() }
      { isRequiredSwitchInput() }
      { advancedConfigurationButton() }
      { deleteButton() }
      { advancedConfigurationModal() }
    </tr>
  )
}

export default WorkflowStageFileItemAttributes;


const WorkflowStageFileItemModalAdvancedConfiguration = props => {
  const {
    openModalAdvancedConfiguration,
    currentNode,
    setCurrentNode,
    callbacks: {
      toggleOpenModalAdvancedConfiguration: callbackToggleOpenModalAdvancedConfiguration,
      setFileItem: callbackSetFileItem
    },
    configuration: {
      formName,
      stageForm
    }
  } = props;

  const {
    callbacks: {
      isNodeInput,
    }
  } = useContext(WorkflowDiagramContext);

  const [fileItem, setFileItem] = useState({});

  const setDefaultFileItem = event => {
    setFileItem(props?.fileItem);
  }

  const onChangeFileItem = (event, key) => {
    const type = event.target.type;
    let value = event?.target?.value;

    if(type == 'file'){
      value = event?.target?.files[0]
    }

    setFileItem( prevState => {
      return { ... prevState, [key]: value}
    })
  }

  // ---------- START TEMPLATE FILE ----------

  const templateFileDownloadLink = () => {
    if(fileItem.template){
      const objectUrl = URL.createObjectURL(fileItem.template);
      return(
        <small>
          <a href={ objectUrl } download={ true }>
            Revisar archivo cargado
          </a>
        </small>
      )
    } else if(fileItem.blob_url){
      return(
        <small>
          <a href={ fileItem.blob_url } download={ true }>
            Revisar archivo cargado
          </a>
        </small>
      )
    }
  }


  const templateFileInput = () => {
    if(stageForm == 'output_stage_form'){
      return(
        <FieldError errors={ fileItem?.errors?.template || [] }>
          <FormGroup>
            <Label
              htmlFor={ inputId(formName, 'template') }
            >
              { I18n.t('activerecord.attributes.workflow/stage_file_item.template') }
            </Label>
            <Input
              type='file'
              onChange={ e => onChangeFileItem(e, 'template') }
              id={ inputId(formName, 'template') }
              name={ inputName(formName, 'template') }
            />
            { templateFileDownloadLink() }
          </FormGroup>
        </FieldError>
      )
    }
  }
  // ---------- END TEMPLATE FILE ----------

  // ---------- START HELPING TEXT ----------
  const helpingTextInput = () => {
    return(
      <FieldError errors={ fileItem?.errors?.helping_text || [] }>
        <FormGroup>
          <Label
            htmlFor={ inputId(formName, 'helping_text') }
          >
            { I18n.t('activerecord.attributes.workflow/stage_file_item.helping_text') }
          </Label>
          <Input
            type='textarea'
            onChange={ e => onChangeFileItem(e, 'helping_text') }
            id={ inputId(formName, 'helping_text') }
            name={ inputName(formName, 'helping_text') }
            value={ fileItem?.helping_text || '' }
          />
        </FormGroup>
      </FieldError>
    )
  }

  // ---------- END HELPING TEXT ----------

  const saveAdvancedConfiguration = () => {
    callbackToggleOpenModalAdvancedConfiguration()
    callbackSetFileItem(fileItem);
  }

  // ---------- START BRIDGE INFORMATION ----------

  const onChangeRequireAutocompleteByInputData = event => {
    const { checked }  = event.target;

    let bridgeFileItems = [... currentNode.data.bridge_file_items];

    const index = _.findIndex(bridgeFileItems, fi => {
      return String(fi.output_file_custom_id) == String(fileItem.custom_id)
    })

    if(index >= 0){
      bridgeFileItems[index]['require_autocomplete_by_input_data'] = checked;
    } else {
      bridgeFileItems.push({
        output_file_custom_id: fileItem.custom_id,
        require_autocomplete_by_input_data: checked
      })
    }

    setCurrentNode(prevState => {
      return {
        ...prevState,
        data: {
          ...prevState.data,
          bridge_file_items: bridgeFileItems
        }
      }
    })
  }


  const onChangeAutocompleteByInputData = (event, key) => {
    let value = event.target.value;

    if(event.target.type == 'checkbox'){
      value = event.target.checked;
    }

    let bridgeFileItems = [... currentNode.data.bridge_file_items];

    const index = _.findIndex(bridgeFileItems, fi => {
      return String(fi.output_file_custom_id) == String(fileItem.custom_id)
    })

    if(index >= 0){
      bridgeFileItems[index]['input_file_custom_id'] = value;
    } else {
      bridgeFileItems.push({
        output_file_custom_id: fileItem.custom_id,
        input_file_custom_id: value
      })
    }

    setCurrentNode(prevState => {
      return {
        ...prevState,
        data: {
          ...prevState.data,
          bridge_file_items: bridgeFileItems
        }
      }
    })
  }

  const requireAutocompleteByInputData = useMemo(() => {
    const currentCustomId = fileItem.custom_id;

    const currentBridgeInformation = _.find(currentNode.data.bridge_file_items, { 'output_file_custom_id': currentCustomId })
    return !!currentBridgeInformation?.require_autocomplete_by_input_data
  }, [fileItem.custom_id, currentNode.data.bridge_file_items])

  const requireAutompleteByInputDataSwitch = () => {
    if(stageForm == 'output_stage_form' && !isNodeInput(currentNode)){
      return(
        <FormGroup>
          <div className='custom-switch'>
            <FieldError errors={ [] }>
              <Input
                className='custom-control-input'
                type='checkbox'
                value={ requireAutocompleteByInputData }
                // name={ `${ inputName( formName, 'clone_folder_ids')  }[]` }
                id={ inputId( formName, `require_autocomplete_by_input_data_${ fileItem.custom_id }`) }
                onChange={ event => onChangeRequireAutocompleteByInputData(event, 'require_autocomplete_by_input_data') }
                checked={ requireAutocompleteByInputData }

              />
              <Label
                className='custom-control-label'
                htmlFor={ inputId( formName, `require_autocomplete_by_input_data_${ fileItem.custom_id }`) }
              >
                Autocompletar
              </Label>
            </FieldError>
          </div>
        </FormGroup>
      )
    }
  }

  const autocompleteInputFileCustomIdSelectedOption = useMemo(() => {
    const data = _.find(currentNode?.data?.bridge_file_items, { output_file_custom_id: fileItem.custom_id })
    if(data){
      const inputFileItem = _.find(currentNode?.data?.input_stage_form.file_items, { custom_id: data.input_file_custom_id })

      return inputFileItem ? { value: inputFileItem.custom_id, label: inputFileItem.name } : null
    } else {
      return null
    }
  }, [fileItem, currentNode?.data.input_stage_form, currentNode?.data?.bridge_file_items])

  const autocompleteInputFileCustomIdSelectOptions = () => {
    return _.map(currentNode?.data?.input_stage_form.file_items, _fileItem =>({
      value: _fileItem.custom_id,
      label: _fileItem.name
    }))
  }

  const autocompleteByInputDataSelect = () => {
    if(stageForm == 'output_stage_form' && requireAutocompleteByInputData){
      return(
        <FormGroup >
          <FieldError errors={ [] }>
            <Select
              id={ inputId( formName, `input_file_custom_id_${ fileItem.custom_id }`) }
              onChange={ e => onChangeAutocompleteByInputData({ target: { value: e?.value } }, 'input_file_custom_id' ) }
              value={ autocompleteInputFileCustomIdSelectedOption }
              options={ autocompleteInputFileCustomIdSelectOptions() }
              placeholder={ `-- Selecciona un dato de entrada --` }
            />
          </FieldError>
        </FormGroup>
      )
    }
  }

  // ---------- END BRIDGE INFORMATION ----------
  return(
    <Modal
      isOpen={ openModalAdvancedConfiguration }
      toggle={ callbackToggleOpenModalAdvancedConfiguration }
      unmountOnClose={ true }
      size={ 'lg' }
      onOpened={ event => setDefaultFileItem() }
    >
      <ModalHeader
        toggle={ callbackToggleOpenModalAdvancedConfiguration }
      >
        Configuración Avanzada
        <small className='d-block text-muted'>
          { `${ currentNode?.data?.label || 'Etapa sin nombre'} - ${ fileItem.name }`}
        </small>
      </ModalHeader>
      <ModalBody>
        { helpingTextInput() }
        { templateFileInput() }
        { requireAutompleteByInputDataSwitch() }
        { autocompleteByInputDataSelect() }
      </ModalBody>
      <ModalFooter>
        <Button color="default" onClick={ callbackToggleOpenModalAdvancedConfiguration }>
          { I18n.t('actions.close') }
        </Button>{' '}
        <Button color="success" onClick={ e => saveAdvancedConfiguration() }>
          { I18n.t('actions.save') }
        </Button>
      </ModalFooter>
    </Modal>
  )
}
